import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { emptyFunc, isNullOrUndefinedOrEmpty } from '../../../../helpers/common';
import { propBool, propShape } from '../../../../helpers/custom-prop-types';
import BlurText from '../../../Ui/Common/BlurText';
import HtmlLink from '../../../Ui/Common/HtmlLink';
import Image from '../../../Ui/Common/Image';
class SectionServiceOne extends Component {
    constructor(props) {
        super(props);
        this.getState = (props) => {
            const { solution } = props;
            const points = solution.point
                .split('\n')
                .filter((v) => !isNullOrUndefinedOrEmpty(v))
                .map((row, key) => ({ key, row }));
            return {
                points,
            };
        };
        this.state = this.getState(props);
    }
    shouldComponentUpdate(nextProps) {
        const { solution: { point }, } = this.props;
        const { solution: { point: nextPoint }, } = nextProps;
        if (point !== nextPoint) {
            this.setState(this.getState(nextProps));
        }
        return true;
    }
    render() {
        const { isBlur, solution: { id, thumbnail, title }, } = this.props;
        const { points } = this.state;
        return (_jsxs(HtmlLink, Object.assign({ className: 'about-service-one-box pointer', isNoLinkComponent: isBlur ? 'div' : undefined, onClickNoLink: emptyFunc, rel: 'noopener noreferrer', target: '_blank', to: `/solutions/${id}` }, { children: [_jsx("div", Object.assign({ className: 'about-service-one-box-thumbnail-box' }, { children: _jsx("div", Object.assign({ className: 'about-service-one-box-thumbnail-wrapper is-thumbnail' }, { children: _jsx(Image, { allowContextMenu: false, alt: '', isBlur: isBlur, isObjectFit: true, src: thumbnail, useImage: true }) })) })), _jsxs("div", Object.assign({ className: 'about-service-one-box-description-box flex-direction-column' }, { children: [_jsxs("div", Object.assign({ className: 'about-service-one-description' }, { children: [_jsx(BlurText, Object.assign({ component: 'h3', isBlur: isBlur }, { children: title })), points.length > 0 && (_jsx("ul", Object.assign({ className: 'oranienbaum_ul_list' }, { children: points.map(({ key, row }) => (_jsx(BlurText, Object.assign({ component: 'ol', isBlur: isBlur }, { children: row }), key))) })))] })), _jsx("div", Object.assign({ className: 'about-service-one-button-row' }, { children: _jsx(BlurText, Object.assign({ className: 'about-service-one-button-row-text', component: 'span', isBlur: isBlur }, { children: "\u8A73\u7D30\u3092\u898B\u308B" })) }))] }))] })));
    }
}
SectionServiceOne.propTypes = {
    isBlur: propBool().isRequired,
    solution: propShape().isRequired,
};
export default SectionServiceOne;
